// import { SafetyOutlined, CloudOutlined, TeamOutlined, ToolOutlined } from '@ant-design/icons';
import React, { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import { Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from '../common.module.less';
import FeatureList from './FeatureList';
import { getCompanyLogo } from '@/services/ant-design-pro/api';
import { LanguageSwitch, PageLoading } from '@/components';

const UserLayout: React.FC = () => {
  const [companyLogo, setCompanyLogo] = useState<string>('/company_logo.jpg');
  const { t } = useTranslation();

  useEffect(() => {
    const fetchCompanyLogo = async () => {
      try {
        const response = await getCompanyLogo();
        if (response.success && response.data) {
          // 使用返回的URL，该URL包含了时间戳以防止缓存问题
          setCompanyLogo(response.data);
        }
      } catch (error) {
        console.error('获取企业logo失败:', error);
      }
    };

    fetchCompanyLogo();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.leftSection}>
        <div className={styles.leftContent}>
          <img src="/company_logo.png" alt="logo" className={styles.mainLogo} />
          <h1 className={styles.mainTitle}>{t('pages.layouts.userLayout.title')}</h1>
          <p className={styles.description}>{t('pages.layouts.userLayout.subtitle')}</p>

          <FeatureList />
        </div>
      </div>

      <div className={styles.rightSection}>
        <div className={styles.formContainer}>
          <img alt="client-logo" src={companyLogo} className={styles.clientLogo} />
          <Suspense fallback={<PageLoading />}>
            <Outlet />
          </Suspense>
          <Divider style={{ margin: '24px 0 16px 0' }} />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <LanguageSwitch mode="button" showText />
          </div>
        </div>
        <div className={styles.copyright}>版权所有 ©2025 续创信息技术咨询（成都）有限公司</div>
      </div>
    </div>
  );
};

export default UserLayout;
